import React from "react";
import SurveysList from "components/surveys/SurveysList";
import Loading from "components/common/Loading";
import useSurveys from "hooks/surveys/useSurveys";
import useAuth from "hooks/useAuth";
import { createSurvey } from "api/surveys.api";

const Surveys = () => {
  const {
    surveys,
    isLoading,
    getNextPage,
    page,
    setPage,
    hasMoreItems,
    totalCount,
    counts,
  } = useSurveys();
  const { currentUser } = useAuth();
  return isLoading && surveys.length === 0 ? (
    <Loading />
  ) : (
    <SurveysList
      surveys={surveys}
      totalCount={totalCount}
      counts={counts}
      currentUserId={currentUser?.id}
      currentUserType={currentUser?.type}
      currentUserDisplayName={currentUser?.displayName}
      isLoadingNextPage={isLoading}
      hasMoreItems={hasMoreItems}
      getNextPage={getNextPage}
      page={page}
      setPage={setPage}
      createSurvey={createSurvey}
    />
  );
};

export default Surveys;
